<template>
  <div>
    <!-- empty div required for root dialog component -->
    <b-modal
      ref="modal"
      :title="
        $t('orders.name') +
        ` #${orderInfo.invoice_number} - ${orderInfo.status_label}`
      "
      centered
      size="lg"
    >
      <order-sides
        v-if="orderInfo.user || orderInfo.recipient"
        :order="orderInfo"
        class="mb-4"
      />
      <order-items v-if="orderInfo.items" :order="orderInfo" class="mb-4" />
      <order-details :order="orderInfo" />
      <div slot="modal-footer">
        <b-button
          v-if="refundable"
          :disabled="orderInfo.refund_requested"
          type="button"
          class="mr-2"
          variant="light"
          @click="requestRefund"
        >
          <span v-if="orderInfo.refund_requested">
            {{ $t('orders.refund_requested') }}
            <i class="icon-check"></i>
          </span>
          <span v-else>
            {{ $t('orders.request_refund') }}
          </span>
        </b-button>
        <a
          v-if="invoiceUrl"
          :href="invoiceUrl"
          target="_blank"
          class="btn btn-light"
        >
          {{ $t('orders.view_invoice_pdf') }}
          <i class="icon-new-tab"></i>
        </a>
      </div>
    </b-modal>
  </div>
</template>

<script>
import OrdersApi from './Api'
import OrderSides from './OrderSides'
import OrderItems from './OrderItems'
import OrderDetails from './OrderDetails'

export default {
  name: 'InvoiceView',

  components: {
    OrderSides,
    OrderItems,
    OrderDetails,
  },

  props: {
    // eslint-disable-next-line vue/require-default-prop
    order: Object,
  },

  data() {
    return {
      orderInfo: this.order,
      invoiceUrl: null,
    }
  },

  computed: {
    refundable() {
      return false
    },
  },

  mounted() {
    const modal = this.$refs.modal

    modal.show()

    modal.$on('shown', () => {
      this.$uiBlocker(
        new OrdersApi().find(this.order.id).then((result) => {
          this.orderInfo = result.data
          this.invoiceUrl = result.invoice_url
        }),
        modal.$refs.content
      )
    })

    modal.$on('close', () => {
      this.$close()
    })
  },

  methods: {
    async requestRefund() {
      if (
        !(
          await this.$alert.question(
            this.$t('orders.messages.confirm_request_refunding')
          )
        ).value
      ) {
        return
      }

      this.$uiBlocker(
        new OrdersApi().requestRefund(this.order).then((result) => {
          this.$toast.success(result.message)
          this.$close()
        }),
        this.$refs.modal
      )
    },
  },
}
</script>
